export const user = {
  newAccount: "New Account",
  editAccount: "Edit Account",
  accountDetails: "Account Details",
  workXConnectCloudSettings: "CWorkX Connect Cloud Settings",
  emailAlreadyExists: "The Email address already exists.",
  driverSameEmailAddress:
    "A driver is registered under the same Email address. ",
  emailHasBeenRegisteredIsPullInformation:
    "Account information is loaded from a user that is registered under the same Email address. | Account information is loaded from a driver that is registered under the same Email address.",
  administrator: "administrator",
  fleetManager: "Fleet Manager",
  driver: "driver",
  // Format: type ["detail1", "detail2", ......]
  deleteTip:
    "The account {0} will be deleted. Are you sure you want to proceed? | The accounts {0} will be deleted. Are you sure you want to proceed?",
  changeEmail: "Change Email",
  changeEmailTips:
    "A Verification code has been sent to the new email address. Please input the code to validate.",
  changeEmailError: "The Verification code is incorrect.",
  active: "Active",
  activationPending: "Activation Pending",
  removeOnDate: "Remove on {0}",
  sendActivationNotice: "Send Activation Notice",
  sendActivationNoticeSuccessfully: "Sent the activation Email successfully.",
};
